import React from 'react';

const NotFound = () => {
    return (
        <div className="text-center">
            <img src="https://image.freepik.com/free-vector/oops-404-error-with-broken-robot-concept-illustration_114360-1932.jpg" alt="" />
        </div>
    );
};

export default NotFound;